import { useMMKVDevTools } from '@dev-plugins/react-native-mmkv';
import { useReactQueryDevTools } from '@dev-plugins/react-query';
import { useReduxDevTools } from '@dev-plugins/redux';
import { useQueryClient } from '@tanstack/react-query';
import { storage } from '@unistocks/shared/storage';
import { useStore } from 'react-redux';

/**
 * Use dev tools for debugging and development.
 * All expo plugins are noops in production.
 */
export const useDevTools = () => {
  const queryClient = useQueryClient();
  const store = useStore();
  useReactQueryDevTools(queryClient);
  useMMKVDevTools({ storage });
  useReduxDevTools(store);
};
